import $ from 'jquery';

$(function() {
    $('.button, .wp-block-button__link, .main-nav a, .footer-nav a, a.wave, .wave a, a .wave, a.more-button')
        .each(function() {
        var $this = $(this),
            $elems = $this.contents(),
            elements = [],
            $element,
            offset = 0,
            text,
            textWords,
            i,
            k,
            char;

        $elems.each(function() {
            var $elem = $(this);

            if (this.nodeType === 3) {
                textWords = $elem.text().trim().split(/\s/);
                if (textWords.length === 1 && textWords[0] === "") {
                    return;
                }
                for (k in textWords) {
                    $element = $('<div class="word"></div>');
                    text = textWords[k];
                    for (i = 0; i < text.length; i++) {
                        char = text.charAt(i);
                        if (char === ' ') {
                            char = '&nbsp;';
                        }
                        $element.append($('<span style="animation-delay: ' + offset + 'ms;">' + char + '</span>'));
                        offset += 10;
                    }
                    if (k > 0) {
                        if (!$this.hasClass('white-space')) {
                            elements.push('&nbsp;');
                        } else {
                            elements.push(' ');
                        }
                    }
                    elements.push($element);
                }
            } else {
                elements.push($('<div class="word"><span style="animation-delay: ' + offset + 'ms;">' + this.outerHTML + '</span></div>'));
                offset += 10;
            }
        });
        $this.html('');
        for (i in elements) {
            $this.append(elements[i]);
        }
    });
});
